/**
 * EnviarCotacaoDialog - Modal de escolha do método de envio da cotação (extraído de Compras.jsx).
 */
import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import { Button } from '../ui/button';
import { MessageCircle, Send, FileText } from 'lucide-react';

const EnviarCotacaoDialog = ({ cotacao, onClose, onConfirmarEnvio }) => {
  return (
    <Dialog open={!!cotacao} onOpenChange={() => onClose()}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>Enviar Cotação</DialogTitle>
        </DialogHeader>

        {cotacao && (
          <div className="space-y-4 mt-4">
            <p className="text-sm text-gray-600">
              Cotação: <span className="font-medium">{cotacao.numero}</span>
            </p>
            <p className="text-sm text-gray-600">
              Fornecedores: <span className="font-medium">{cotacao.fornecedores?.length || 0}</span>
            </p>

            <div className="space-y-2">
              <Button
                className="w-full justify-start"
                variant="outline"
                onClick={() => onConfirmarEnvio('whatsapp')}
                data-testid="btn-enviar-whatsapp"
              >
                <MessageCircle className="w-4 h-4 mr-2 text-green-600" />
                Enviar via WhatsApp
              </Button>
              <Button
                className="w-full justify-start"
                variant="outline"
                onClick={() => onConfirmarEnvio('email')}
                data-testid="btn-enviar-email"
              >
                <Send className="w-4 h-4 mr-2 text-blue-600" />
                Enviar por E-mail
              </Button>
              <Button
                className="w-full justify-start"
                variant="outline"
                onClick={() => onConfirmarEnvio('pdf')}
                data-testid="btn-enviar-pdf"
              >
                <FileText className="w-4 h-4 mr-2 text-red-600" />
                Gerar PDF e enviar manualmente
              </Button>
            </div>

            <div className="border-t pt-4">
              <Button
                className="w-full"
                onClick={() => onConfirmarEnvio('status')}
                data-testid="btn-enviar-status"
              >
                Apenas marcar como enviado
              </Button>
            </div>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default EnviarCotacaoDialog;
